import {
	closeCampaigns,
	initCampaignsDemo,
	initCampaignsWp,
	initCampaignsPreview,
	initCampaignsBgClick,
	initMobilePreview,
} from 'optinmonster-js-library/src/utils/omapi';
import { urls } from 'optinmonster-js-library/src/vue/utils';
import { loadApiScript } from 'optinmonster-js-library/src/utils/apiJsScript';

export const templatePreviewsSetup = {
	created() {
		this.listenApiLoaded();

		// Ensure campaigns are flagged as demos.
		initCampaignsDemo();
		// Ensure campaigns are flagged as wp.
		initCampaignsWp();
		// Make previews closeable by clicking background.
		initCampaignsBgClick();
		// Disable form fields
		initCampaignsPreview();
		// Handle mobile template previews
		initMobilePreview();

		this.$store.subscribe((mutation) => {
			const ignore = [
				'templates/setLoadingPreview',
				'templates/setPreviewing',
				'templates/filterOptions',
				'templates/templates',
				'templates/permittedTypes',
				'templates/recentTemplates',
				'templates/popular',
				'templates/setApiLoaded',
			];
			const triggers = ['route/ROUTE_CHANGED'];

			let shouldClose = mutation.type.startsWith('templates/') && !ignore.includes(mutation.type);
			if (!shouldClose) {
				shouldClose = triggers.includes(mutation.type);
			}

			if (shouldClose) {
				this.closeAllPreviews();
			}
		});
	},
	beforeDestroy() {
		initCampaignsDemo(false);
		initCampaignsWp(false);
		initCampaignsPreview(false);
		initCampaignsBgClick(false);
		initMobilePreview(false);
	},
	methods: {
		listenApiLoaded(cb = 'addEventListener') {
			['om.Api.init', 'om.Main.init', 'om.Campaigns.init', 'om.Campaign.init'].forEach((evt) =>
				document[cb](evt, this.setApiLoaded)
			);
		},
		/**
		 * Handle finishing the API load.
		 *
		 * Remove the apiLoaded event listener and set the
		 * apiLoaded flag to true once the api has loaded.
		 *
		 * @returns {void}
		 */
		setApiLoaded() {
			this.listenApiLoaded('removeEventListener');
			this.$store.commit('templates/setApiLoaded');
		},
		/**
		 * Handles closing all open campaigns and resetting preview state.
		 *
		 * @returns {void}
		 */
		closeAllPreviews() {
			closeCampaigns();
			this.$store.commit('templates/setLoadingPreview', '');
			this.$store.commit('templates/setPreviewing', '');
		},
		/**
		 * Handles generating our api script tag.
		 *
		 * @param {string} scriptId The script id.
		 * @param {int} accountid The account id.
		 * @param {int} userId The user id.
		 *
		 * @returns {string} The script tag
		 */
		loadApiScript(scriptId, accountid, userId) {
			return loadApiScript(urls.apiJs(), scriptId, accountid, userId);
		},
	},
};
